// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".etn_menu .active[data-v-2b962e6e]{background:#686868}.etn_menu .active .etn_hide[data-v-2b962e6e],.etn_menu .active a .svg[data-v-2b962e6e]{color:#fff!important}@media (max-width:799px){.edicion_top_nav .etn_menu>li.btn-success_container[data-v-2b962e6e],.edicion_top_nav .etn_menu>li>a.btn-success[data-v-2b962e6e]{min-width:80px!important;width:80px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
